import {MeasurementData} from '@/views/system/measurements/interfaces';

/*
    Найти измерение в списке измерений по индетнификатору
*/
export function getMeasurementById(
  measurements: MeasurementData[],
  id: number,
): MeasurementData | null {
  const data = measurements.filter(x => x.id === id);
  if (data.length) return data[0];
  return null;
}
